<template>
  <section class="gateManageDiv p-4 space-y-4">
    <viewTitle title="业务管理 / 基础数据管理 / 门岗管理" :showReturn="false" />

    <!-- 按钮组 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%">
        <el-button
          v-has="['c-base-mp-door-add']"
          type="primary"
          @click="addNewGate"
          size="medium"
          >新建门岗</el-button
        >
        <span class="rectl text-sm">状态</span>
        <el-select
          class="ctl rectl"
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important"
          clearable
          placeholder="请输入门岗描述"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
        :fit="true"
      >
        <el-table-column label="门岗描述">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.note || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-else-if="scope.row.state === 2" class="color67">
              已禁用
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="进厂顺序">
          <template slot-scope="scope">
            {{ formatInboundOrder(scope.row.inbound_order) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.update_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown
                trigger="click"
                :hide-on-click="true"
                v-has="[
                  'c-base-mp-door-update',
                  'c-base-mp-door-update',
                  'c-base-mp-door-delete'
                ]"
              >
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    v-has="['c-base-mp-door-update']"
                    @click.native.stop="editDetail(scope.row)"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-door-update']"
                    @click.native.stop="enable(scope.row)"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-door-update']"
                    @click.native.stop="enable(scope.row)"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-door-delete']"
                    @click.native.stop="delDetail(scope.row)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <!-- 弹窗 -->
    <el-dialog
      label-position="left"
      label-width="80px"
      width="600px"
      :close-on-click-modal="false"
      :title="dialogData.type === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogData.show"
    >
      <el-form label-width="100px">
        <el-form-item label="门岗描述:" required>
          <el-input
            placeholder="请输入门岗描述"
            v-model="params.gateName"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input placeholder="请输入备注" v-model="params.remark"></el-input>
        </el-form-item>
        <el-form-item label="进厂顺序:" required>
          <el-select
            v-model="params.inboundOrder"
            placeholder="请选择进厂顺序"
            style="width: 100%;"
          >
            <el-option
              v-for="item in inboundOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogData.show = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirm" size="small"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import confirm from "@/components/elementPlus/packages/confirm";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        id: 0,
        state: 0, // 状态
        keyword: "", // 关键字搜索
        gateName: "", // 门岗描述
        remark: "", // 备注
        inboundOrder: 1 // 门岗进厂顺序
      },
      stateOption: ["全部", "正常", "已禁用"],
      inboundOrderOptions: [
        { label: "先过磅后进门", value: 1 },
        { label: "先进门后过磅", value: 2 }
      ],
      maxHeight: 0,
      tableData: [], // 表格数据
      dialogData: {
        show: false,
        type: "",
        label: ""
      } // 弹窗
    };
  },

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mixins: [mixinTableLyout],

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    this.getList();
  },

  async activated() {},

  created() {},

  methods: {
    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 修改状态
    changeState(val) {
      this.page = 1;
      this.params.state = val;
      this.getList();
    },
    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_door",
        data: {
          state: this.params.state,
          page: this.page,
          page_size: this.pageSize,
          keyword: this.params.keyword
        }
      });
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 新增门岗
    addNewGate() {
      this.dialogData.type = "add";
      this.dialogData.show = true;
      this.params.id = 0;
      this.params.gateName = "";
      this.params.remark = "";
      this.params.inboundOrder = 1;
    },

    // 编辑
    editDetail(row) {
      console.log(row);
      this.dialogData.type = "edit";
      this.dialogData.show = true;
      this.params.id = row.id;
      this.params.gateName = row.name;
      this.params.remark = row.note;
      this.params.inboundOrder = Number.isInteger(row.inbound_order)
        ? row.inbound_order
        : Number(row.inbound_order || 1);
      this.rowDataObj = row;
    },

    // 启用/禁用
    enable(item) {
      confirm({
        message: `确定要禁用“<span class='color67'>${item.name}</span>”吗？`,
        confirmAc: () => {
          this.$common
            .http({
              url: "/api/queue/admin/enable_door",
              data: {
                id: item.id
              }
            })
            .then(res => {
              if (res.data.data) {
                this.$common.pcToastSuccess(
                  `${item.state === 1 ? "禁用成功" : "启用成功"}`
                );
              }
              this.getList();
            });
        },
        confirmAcClass: "btnConfirmPrimary",
        cancelAcClass: "btnCancel"
      });
    },

    // 删除
    delDetail(row) {
      confirm({
        message: `确认删除基地门岗，删除后数据将无法恢复！`,
        confirmAc: () => {
          let id = [];
          id.push(row.id);
          let str = JSON.stringify(id);
          this.$common
            .http({
              url: "/api/queue/admin/delete_door",
              data: {
                ids: str
              }
            })
            .then(res => {
              if (res.data.data) {
                this.$common.pcToastSuccess("删除成功");
              }
              this.getList();
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 确认
    confirm() {
      if (this.params.gateName.trim() === "") {
        this.$common.pcToastFail("门岗描述不能为空");
        return false;
      }
      if (![1, 2].includes(this.params.inboundOrder)) {
        this.$common.pcToastFail("请选择进厂顺序");
        return false;
      }
      this.$common
        .http({
          url: "/api/queue/admin/save_door",
          data: {
            id: this.params.id,
            name: this.params.gateName,
            note: this.params.remark,
            inbound_order: this.params.inboundOrder
          }
        })
        .then(res => {
          console.log(res);
          this.dialogData.show = false;
          if (res.data.data) {
            if (this.dialogData.type === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          this.params.gateName = "";
          this.params.remark = "";
          this.params.inboundOrder = 1;
        });
    },
    // 格式化进厂顺序展示文案
    formatInboundOrder(inboundOrder) {
      return Number(inboundOrder) === 2 ? "先进门后过磅" : "先过磅后进门";
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 44; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 200; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxHeight = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.gateManageDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 129px);
    position: relative;
  }
}
.page-wrap {
  margin-top: 10px;
}
</style>
